import * as React from "react"
export const Svg_072 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M45.617 16.742 44.45 13.15l-8.866-1.53-4.196-7.96h-3.776l-4.196 7.96-8.866 1.53-1.167 3.592 6.273 6.45-1.284 8.906 3.055 2.22 8.073-3.974 8.073 3.973 3.055-2.22-1.284-8.905 6.273-6.45Z"
    />
    <path
      fill="url(#b)"
      d="M52.003 42.488v8.145H42.15v4.707H59V42.488h-6.997Z"
    />
    <path
      fill="url(#c)"
      d="M6.994 42.488H0V55.34h16.848v-4.707H6.994v-8.145Z"
    />
    <path fill="url(#d)" d="M10.451 34.324h38.095v12.852H10.451V34.323Z" />
    <defs>
      <linearGradient
        id="a"
        x1={20.837}
        x2={35.062}
        y1={8.259}
        y2={32.465}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={46.046}
        x2={51.311}
        y1={44.416}
        y2={55.587}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={3.896}
        x2={9.161}
        y1={44.416}
        y2={55.586}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={19.261}
        x2={21.988}
        y1={36.252}
        y2={49.335}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)